import { APP_CONFIG } from '../constants';
import { storageService, STORAGE_KEYS } from '../services/storageService';
import { createErrorLogger } from './errorHandler';

const logger = createErrorLogger('initialize');


export const initialize = async () => {
    const entityConfigCache = storageService.getCachedData(
        STORAGE_KEYS.ENTITY_CONFIG.DATA,
        STORAGE_KEYS.ENTITY_CONFIG.TIMESTAMP,
        APP_CONFIG.REFRESH_INTERVAL_MS
    );

    const promises = [];

    if (!entityConfigCache.isValid) {
        promises.push(
            storageService.fetchAndUpdateEntityConfiguration()
                .catch(err => logger.error('Failed to fetch entity configuration', err))
        );
    }

    if (promises.length > 0) {
        await Promise.all(promises);
    }
};
